const mobile_ok = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33473)">
      <path d="M17 4H20V20H17V4ZM5 14H8V20H5V14ZM11 9H14V20H11V9Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1_33473">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
export default mobile_ok;
